import Service from './Service';
import {isNewCashOffer, isNewFinanceOffer} from '-/util/util';

const DEALINFO_SET = 'DEALINFO_SET';
const DEALINFO_SETDATA = 'DEALINFO_SETDATA';
const reducerName = 'dealInfo';

const set = (state, key, value) => {
    return {
        ...state,
        [key]: value
    };
};

const reducer = (state = {}, action) => {
    const {type, payload} = action;
    switch (type) {
        case DEALINFO_SET: {
            const {key, value} = payload;
            return set(state, key, value);
        }
        case DEALINFO_SETDATA: {
            return {
                ...state,
                ...payload
            };
        }
    }
    return state;
};

class DealInfoService extends Service {
    constructor() {
        super();

        if (!DealInfoService.instance) {
            DealInfoService.instance = this;
        }
        return DealInfoService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    isCashDeal() {
        const state = this.getReducerState();

        if (state.dealType === 'cash') {
            // prefer from state
            return true;
        } else {
            // but fallback to url for new offers
            return isNewCashOffer();
        }
    }

    isFinanceDeal() {
        const state = this.getReducerState();

        if (state.dealType === 'finance') {
            // prefer from state
            return true;
        } else {
            // but fallback to url for new offers
            return isNewFinanceOffer();
        }
    }

    set(key, value) {
        this.store.dispatch({
            type: DEALINFO_SET,
            payload: {
                key,
                value
            }
        });
    }

    setData(data) {
        this.store.dispatch({
            type: DEALINFO_SETDATA,
            payload: data
        });
    }

    getDataForSave() {
        const obj = this.getReducerState();
        const {newCurrMonthlyPayment, newExistingRate, newPurchaseDate, newOriginalTerm} = obj;

        if (newCurrMonthlyPayment) {
            obj.currMonthlyPayment = newCurrMonthlyPayment;
        }

        if (newExistingRate) {
            obj.existingRate = newExistingRate;
        }

        if (newPurchaseDate) {
            obj.purchaseDate = newPurchaseDate;
        }

        if (newOriginalTerm) {
            obj.originalTerm = newOriginalTerm;
        }

        return obj;
    }
}

export default new DealInfoService();
